module.exports = __webpack_public_path__ + "img/Travel-Bag-Filled.ca522115.svg";